import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { MenuDto } from "../dtos/menu/menuDto";
import { getData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/menu`;

export const getMenuList = async () => {

	const url = `${baseUrl}`;

    return await getData<ResponseDto<MenuDto[]>>(url);
}

export const getMenuModalList = async () => {

	const url = `${baseUrl}/modal`;

    return await getData<ResponseDto<MenuDto[]>>(url);
}

export const getThirdMenuModalList = async (keyword?: string) => {
    const url = `${baseUrl}/third-modal`;
    return await getData<ResponseDto<MenuDto[]>>(url, {
        params: { keyword },
    });
};